import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ffrdc',
  templateUrl: './ffrdc.component.html',
  styleUrls: ['./ffrdc.component.css']
})
export class FfrdcComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
